import React from 'react';
import PropTypes from 'prop-types';
import styles from './Navigator.module.scss';

const Navigator = ({children, clickHandler, disabled}) => {

    const classes = disabled ? [styles.nav, styles.disabled].join(' ') : styles.nav;
    clickHandler = disabled ? () => null : clickHandler;

    return (
        <div className={classes} onClick={clickHandler}>
            {children}
        </div>
    );
};

Navigator.propTypes = {
    children: PropTypes.any,
    disabled: PropTypes.bool,
    clickHandler: PropTypes.func,
};

Navigator.defaultProps = {
    children: null,
    disabled: false,
    clickHandler: () => null,
};

export default Navigator;
